<template>
  <div>
    <div class="video-container" :style="!videoLoaded ? 'display: unset;' : 'display: none;'">
      <div id="success">
        <svg class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
          <circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none" />
          <path class="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8" />
        </svg>
      </div>
      <p class="title-text">{{ lang === 'en' ? 'Generation completed!' : '생성이 완료되었습니다!' }}</p>
      <p class="title-text">{{ lang === 'en' ? 'Rendering video ...' : '동영상 준비 중 ...' }}</p>
    </div>

    <div class="video-container" :style="videoLoaded ? 'display: unset;' : 'display: none;'">
      <video autoplay loop muted id="vid" style="max-width: 1000px; max-height: 540px;">
        <source :src="videoUrl" type="video/mp4" />
      </video>
      <div class="done-bar">
        <b-button 
          block 
          size="lg" 
          variant="primary" 
          @click="goHomeEmit" 
          style="font-size: 48px; width: 400px; margin: auto"
        >
          {{ lang === 'en' ? 'Go to Home' : '메인 화면으로 이동' }}
        </b-button>

        <span 
          class="d-inline-block" 
          tabindex="0" 
          v-b-tooltip.right 
          :title="lang === 'en' ? 'Currently Unavailable' : '현재 지원하지 않습니다.'"
        >
          <b-button 
            block 
            size="lg" 
            variant="primary" 
            disabled 
            style="font-size: 48px; width: 400px; margin: auto"
          >
            {{ lang === 'en' ? 'Download' : '다운로드' }}
          </b-button>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VideoView',

  props: {
    lang: {
      type: String,
      required: true
    },
    videoUrl: {
      type: String,
      required: true
    },
    videoLoaded: {
      type: Boolean,
      required: true
    },
    timestampFromHistory: {
      type: String,
      required: false
    }
  },

  methods: {
    goHomeEmit() {
      this.$emit('goHome')
    },
    goFailPageEmit() {
      this.$emit('goFailPage')
    },
    async showModal() {
      await this.$bvModal.msgBoxConfirm(this.lang=='en' ? 'It seems that the link has expired. Remove history?':'동영상 시청 유효기한이 만료되었습니다. 기록을 삭제할까요?', {
        okVariant: 'danger',
        centered: true
      }).then((value) => {
        if (value === true){
          let history = JSON.parse(localStorage.getItem('photolink_history'))
          history = history.filter(i => i.enqueuedDateTimeEN !== this.timestampFromHistory)
          localStorage.setItem('photolink_history', JSON.stringify(history))
        }
      })
      this.goHomeEmit()
    },
  },

  async mounted() {
    let v = document.querySelector("video#vid")
    let sources = v.querySelectorAll('source')
    if (sources.length !== 0) {
      let lastSource = sources[sources.length - 1]

      lastSource.addEventListener('error', async () => {
        // this.goFailPageEmit()
        await this.showModal()
      })
    }
  }
}
</script>

<style scoped>
.video-container {
  margin: auto;
  width: 1000px;
  height: 540px;
}

.done-bar {
  margin-top: 5px; /* 추가 */
  display: grid;
  grid-template-columns: auto auto;
}

video {
  max-width: 900px;
  max-height: 540px;
  width: 100%;
  height: 100%;
  z-index: 2;
}
</style>
